class MutationLoading {
  showLoading(refBtn) {
    refBtn = refBtn.closest(".v-btn");
    refBtn.disabled = true;
    refBtn.classList.add("v-btn--disabled");
    refBtn.querySelector(".v-icon").style.display = "none";
    refBtn.querySelector(".v-progress-circular").style.display = "block";
  }
  hideLoading(refBtn) {
    refBtn = refBtn.closest(".v-btn");
    refBtn.disabled = false;
    refBtn.classList.remove("v-btn--disabled");

    refBtn.querySelector(".v-icon").style.display = "flex";
    refBtn.querySelector(".v-progress-circular").style.display = "none";
  }
  disableButton(refBtn, text) {
    refBtn = refBtn.closest(".v-btn");
    refBtn.disabled = true;
    refBtn.classList.add("v-btn--disabled");
    // If its icon and not text, then end it here
    if (text == "icon") return;
    //refBtn.firstChild.innerText = text || "Proccessing...";
  }
  enableButton(refBtn, text) {
    refBtn = refBtn.closest(".v-btn");
    refBtn.disabled = false;
    refBtn.classList.remove("v-btn--disabled");
    // If its icon and not text, then end it here
    if (text == "icon") return;
    //refBtn.firstChild.innerText = text || "Submit";
  }
}

export default new MutationLoading();
